import React, { useState } from 'react';
import { Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { IconOptionBox, IconPopover, OptionIconSelectorBox, PlaceholderIconOptionBox } from './OptionIconSelector.styles';
import { useTranslation } from 'react-i18next';

interface IconSelectorProps {
  selectedIcon?: string;
  availableIcons: string[];
  onSelect: (icon: string) => void;
  hasError?: boolean;
}

const STORAGE = process.env.REACT_APP_STORAGE as string;

const IconSelector: React.FC<IconSelectorProps> = ({ selectedIcon, availableIcons, onSelect, hasError }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (icon: string) => {
    onSelect(icon);
    handleClose();
  };

  return (
    <>
      <OptionIconSelectorBox onClick={handleOpen} hasError={hasError}>
        {selectedIcon ? (
          <img src={`${STORAGE}${selectedIcon}`} alt={t('events.selectedIcon')} style={{ width: 24, height: 24 }} />
        ) : (
          <PlaceholderIconOptionBox>
            <Typography variant="body2" color="text.secondary">
              {t('events.icon')}
            </Typography>
          </PlaceholderIconOptionBox>
        )}
        <ArrowDropDownIcon fontSize="small" />
      </OptionIconSelectorBox>

      <IconPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {availableIcons.map((icon, index) => (
          <IconOptionBox key={index} onClick={() => handleSelect(icon)}>
            <img src={`${STORAGE}${icon}`} alt={t('events.optionIcon')} style={{ width: 24, height: 24 }} />
          </IconOptionBox>
        ))}
      </IconPopover>
    </>
  );
};

export default IconSelector;
